import React, { PropsWithChildren } from 'react';
import styled, { ThemeProvider as StyledThemeProvider, css } from 'styled-components';

import { themeDefault } from '@column/column-ui-kit';

import { useSessionStore } from '~/stores/Session';

import { breakpoints, containerBreakpoints } from './breakpoints';
import './themeExtension';
import { themeDark } from './themeDark';
import { themeWarm } from './themeWarm';

interface ThemeProviderProps {}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.secondary.blendToBackground(75)};
  color: ${({ theme }) => theme.foreground};
  height: 100%;

  ${({ theme }) =>
    theme.id !== 'default' &&
    css`
      background: ${theme.body};
    `};
`;

const defaultThemeWithBreakpoints = {
  ...themeDefault,
  breakpoints,
  containerBreakpoints,
};

export const ThemeProvider: React.FC<PropsWithChildren<ThemeProviderProps>> = (props) => {
  const themeType = useSessionStore((state) => state.settings.themeType);

  const themes = new Map([
    ['default', defaultThemeWithBreakpoints],
    ['dark', themeDark],
    ['warm', themeWarm],
    [undefined, defaultThemeWithBreakpoints],
  ]);

  return (
    <StyledThemeProvider theme={themes.get(themeType) ?? defaultThemeWithBreakpoints}>
      <Wrapper>{props.children}</Wrapper>
    </StyledThemeProvider>
  );
};
